/**
 * Dismissed admin announcements, any priority, per user: localStorage plus a
 * CustomEvent so every surface (announcement strip, legacy Header) agrees.
 * Ids dismissed before this was per user (the shared key) still count.
 */

export const CLOSED_UPDATES_STORAGE_KEY = "closedCriticalUpdates";

export const CLOSED_UPDATES_EVENT = "closedCriticalUpdatesUpdated";

const userKey = (uid: string) => `closedAnnouncements_v1_${uid}`;

const readList = (key: string): string[] => {
  try {
    const raw: unknown = JSON.parse(localStorage.getItem(key) ?? "[]");
    return Array.isArray(raw)
      ? raw.filter((x): x is string => typeof x === "string")
      : [];
  } catch {
    return [];
  }
};

/** Dismissed ids for `uid` (and the legacy shared list). */
export const readClosedUpdateIds = (uid?: string | null): string[] => {
  const legacy = readList(CLOSED_UPDATES_STORAGE_KEY);
  return uid
    ? Array.from(new Set([...legacy, ...readList(userKey(uid))]))
    : legacy;
};

export const closeUpdate = (id: string, uid?: string | null): void => {
  const key = uid ? userKey(uid) : CLOSED_UPDATES_STORAGE_KEY;
  const next = Array.from(new Set([...readList(key), id]));
  try {
    localStorage.setItem(key, JSON.stringify(next));
  } catch {
    // Private mode: dismissed for this page only.
  }
  window.dispatchEvent(new Event(CLOSED_UPDATES_EVENT));
};
